enum OrganisationSelectorEvents {
	Selected = 'selected',
}

type OrganisationSelectorEmitters = {
	[OrganisationSelectorEvents.Selected]: (ids: string[]) => void;
};

export { OrganisationSelectorEvents, OrganisationSelectorEmitters };
